import { Root } from "./Root";
import { Content, Item, Trigger, TriggerButton } from "./Item";

export const Accordion = Object.assign(Root, {
  Item,
  Trigger,
  Content,
  TriggerButton,
});
